import { render, staticRenderFns } from "./CrashStatisticsTable.vue?vue&type=template&id=12a514ba&scoped=true&"
import script from "./CrashStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./CrashStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./CrashStatisticsTable.vue?vue&type=style&index=0&id=12a514ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a514ba",
  null
  
)

export default component.exports